module.exports = __webpack_public_path__ + "images/mdj/members/resume/common/common_bg01-d6f58aff8925a61512b9310c17594390.jpg";